import { gql } from '@apollo/client';

export const DEPARTMENT_LIST = gql`
  query departmentList {
    department {
      id
      name
    }
  }
`;

export const DEPARTMENTS_FOR_STUDENT = gql`
  query departmentsForStudent {
    departmentsForStudent {
      id
      name
      users {
        id
        name
        employeeID
      }
    }
  }
`;

export const DEPARTMENTS_FOR_USER = gql`
  query departmentForUser($where: user_public_bool_exp) {
    department {
      id
      name
      users_public(where: $where) {
        id
        firstName
        lastName
        employeeID
      }
    }
  }
`;

export const DEPARTMENT_FOR_RESULT_SHEET = gql`
  query departmentForResultSheet($where: department_bool_exp) {
    department(where: $where) {
      name
    }
  }
`;
